import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Divider,
  Form,
  Input,
  message,
  Modal,
  notification,
  Select,
  Space,
  Typography,
} from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import '../../CampaignRequestor/styles.css';
import { useCampaignRequestorContext } from '../../../../core/components/campaignRequestor/useCampaignRequestorContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import CampaignOrderQueueReviewNotesDialog from './CampaignOrderQueueReviewNotesDialog';

const { Text } = Typography;

export const CampaignOrderQueueReviewQueueSummary = ({
  setShowApprovedDialogSuccess,
  currentCampaignOrder: campaignOrderProp,
}) => {
  const campaignRequestorContext = useCampaignRequestorContext();
  const {
    updateCampaignOrder,
    loadingUpdateCampaignOrder,
    currentCampaignOrder: currentCampaignOrderContext,
    childrenOrg,
    orgCRMIntegrations,
    sendPandaDocFromOpportunity,
    loadingSendPandaDocFromOpportunity,
    fetchSalesforceAccountNameDirect,
    salesforceAccountNameDirect,
    loadingSalesforceAccountNameDirect,
    fetchSalesforceOpportunityProposalFilename,
    salesforceOpportunityProposalFilename,
  } = campaignRequestorContext;

  const currentCampaignOrder = campaignOrderProp || currentCampaignOrderContext;

  const externalCRMCampaignIntegrations =
    currentCampaignOrder?.advertiser?.externalCRMCampaignIntegrations || [];
  console.log('currentCampaignOrder', currentCampaignOrder);

  const [pendingApproval, setPendingApproval] = useState(0);
  const [approved, setApproved] = useState(0);
  const [needsRevision, setNeedsRevision] = useState(0);
  const [hasDeliveryLineItems, setHasDeliveryLineItems] = useState(true);
  const [showNotesDialog, setShowNotesDialog] = useState(false);
  const [showRevisionDialogSuccess, setShowRevisionDialogSuccess] = useState(false);
  const [showPandadocModal, setShowPandadocModal] = useState(false);
  const [selectedSalesforceItems, setSelectedSalesforceItems] = useState(undefined);
  const [name, setName] = useState('');
  const [decisionMakerFirstName, setDecisionMakerFirstName] = useState('');
  const [decisionMakerLastName, setDecisionMakerLastName] = useState('');
  const [decisionMakerTitle, setDecisionMakerTitle] = useState('');
  const [decisionMakerPhone, setDecisionMakerPhone] = useState('');

  const advertiserHasContract =
    currentCampaignOrder?.advertiser?.pricingModel?.hasContract === true;

  const history = useHistory();

  const handleResetNote = async () => {
    try {
      message.loading('Resetting note...', 0);
      await updateCampaignOrder({
        variables: {
          where: {
            id: currentCampaignOrder.id,
          },
          data: {
            reviewNotes: '',
          },
        },
      });
      message.destroy();
      message.success('Note reset successfully');
    } catch (error) {
      message.destroy();
      message.error('Error resetting note');
    }
  };

  const handleRequestRevision = async () => {
    try {
      message.loading('Requesting revision...', 0);
      await updateCampaignOrder({
        variables: {
          where: {
            id: currentCampaignOrder.id,
          },
          data: {
            status: 'REJECTED',
          },
        },
      });
      message.destroy();
      setShowRevisionDialogSuccess(true);
    } catch (error) {
      message.destroy();
      message.error('Error requesting revision');
    }
  };

  // const handleCreateSalesforceData = async () => {
  //   if (!newOpportunityName || newOpportunityName.trim() === '') {
  //     message.error('Must Input an Opportunity Name');
  //     return;
  //   }
  //
  //   try {
  //     message.loading('Creating Opportunity...', 0);
  //
  //     if (
  //       !currentCampaignOrder.advertiser.salesforceId ||
  //       currentCampaignOrder.advertiser.salesforceId.trim() === ''
  //     ) {
  //       message.destroy();
  //       message.error('Salesforce ID on campaign order is required.');
  //       notification.open({
  //         message: 'Salesforce ID Missing',
  //         description: 'Click here to set a Salesforce ID',
  //         onClick: () => {
  //           history.push(`/orgs/${currentCampaignOrder.advertiser.id}`);
  //           notification.destroy();
  //         },
  //         style: { cursor: 'pointer' },
  //       });
  //       return;
  //     }
  //
  //     if (
  //       !currentCampaignOrder.advertiser.billingEmail ||
  //       currentCampaignOrder.advertiser.billingEmail.trim() === ''
  //     ) {
  //       message.destroy();
  //       message.error('Advertiser billing email is required.');
  //       notification.open({
  //         message: 'Advertiser billing Email Missing',
  //         description: 'Click here to set a billing email',
  //         onClick: () => {
  //           history.push(`/orgs/${currentCampaignOrder.advertiser.id}`);
  //           notification.destroy();
  //         },
  //         style: { cursor: 'pointer' },
  //       });
  //       return;
  //     }
  //
  //     const parentOrgs = currentCampaignOrder.advertiser?.parentOrg || [];
  //     const parentOrgHasContract = parentOrgs.some(
  //       (parentOrg) => parentOrg?.pricingModel?.hasContract === true,
  //     );
  //
  //     if (!advertiserHasContract && !parentOrgHasContract) {
  //       message.destroy();
  //       message.error('Salesforce ID and Billing Email is required from parent Org.');
  //       notification.open({
  //         message: 'Salesforce ID and Billing Email Missing',
  //         description: 'Click here to set a Salesforce ID and a Billing Email',
  //         onClick: () => {
  //           history.push(`/orgs/${currentCampaignOrder.advertiser.id}`);
  //           notification.destroy();
  //         },
  //         style: { cursor: 'pointer' },
  //       });
  //     } else {
  //       await updateCampaignOrder({
  //         variables: {
  //           where: {
  //             id: currentCampaignOrder.id,
  //           },
  //           data: {
  //             salesforceId: currentCampaignOrder.salesforceId?.trim() ?? null,
  //           },
  //           newOpportunityName,
  //           shouldCreateOpportunity,
  //           decisionMakerFirstName: decisionMakerFirstName?.trim() || null,
  //           decisionMakerLastName: decisionMakerLastName?.trim() || null,
  //           decisionMakerTitle: decisionMakerTitle?.trim() || null,
  //           decisionMakerPhone: decisionMakerPhone?.trim() || null,
  //         },
  //       });
  //
  //       message.destroy();
  //       message.success('Salesforce Opportunity created successfully');
  //       setNewOpportunityName('');
  //       setDecisionMakerFirstName('');
  //       setDecisionMakerLastName('');
  //       setDecisionMakerTitle('');
  //       setDecisionMakerPhone('');
  //       setShowSalesforceModal(false);
  //       // handleApprove();
  //     }
  //   } catch (error) {
  //     console.error('Error creating Salesforce Opportunity:', error);
  //     message.destroy();
  //     message.error('Error creating Salesforce Opportunity');
  //   }
  // };

  // const handleSalesforceConfirm = async () => {
  //   try {
  //     message.loading('Updating Salesforce Opportunity...', 0);
  //     const integrations = orgCRMIntegrations?.externalCRMCampaignIntegrations || [];
  //     const selectedIntegrations = integrations.filter(integration =>
  //       selectedSalesforceItems.includes(integration.metadata.Name)
  //     );
  //     await Promise.all(
  //       selectedIntegrations.map(integration =>
  //         updateSalesforceOpportunity({
  //           variables: {
  //             opportunityId: integration.metadata.Id,
  //             data: {
  //               Name: currentCampaignOrder.name,
  //               Amount: currentCampaignOrder.budget,
  //               StageName: 'Closed Won',
  //               CloseDate: currentCampaignOrder.endDate,
  //               Description: `Updated Test`
  //             },
  //           },
  //         })
  //       )
  //     );
  //     message.destroy();
  //     message.success('Salesforce Opportunity updated successfully');
  //     setShowSalesforceModal(false);
  //     handleApprove();
  //   } catch (error) {
  //     message.destroy();
  //     message.error('Error updating Salesforce Opportunity');
  //   }
  // };

  const handleApprove = async () => {
    try {
      message.loading('Approving...', 0);

      // Determine the target status based on current status
      let status = 'APPROVED'; // Default for new campaigns (PENDING)

      if (
        currentCampaignOrder.status === 'LIVE' ||
        currentCampaignOrder.status === 'LIVE_PENDING'
      ) {
        status = 'LIVE_APPROVED';
      } else if (currentCampaignOrder.status === 'PAUSED_PENDING') {
        status = 'PAUSED_APPROVED';
      }

      //here condition
      // if (
      //   !currentCampaignOrder.advertiser.salesforceId ||
      //   currentCampaignOrder.advertiser.salesforceId.trim() === ''
      // ) {
      //   setShowSalesforceModal(true);
      //   message.destroy();
      //   message.error('Salesforce ID is required.');
      //   return;
      // }

      if (
        !currentCampaignOrder.advertiser.billingEmail ||
        currentCampaignOrder.advertiser.billingEmail.trim() === ''
      ) {
        message.destroy();
        message.error('Advertiser billing email is required.');
        return;
      }

      await updateCampaignOrder({
        variables: {
          where: {
            id: currentCampaignOrder.id,
          },
          data: {
            status,
          },
        },
      });
      message.destroy();
      setShowApprovedDialogSuccess(true);
    } catch (error) {
      console.error('Error approving campaign order:', error);
      message.destroy();
      message.error('Error approving');
    }
  };

  const handleSendPandaDoc = async () => {
    try {
      message.loading('Sending PandaDoc...', 0);
      await sendPandaDocFromOpportunity({
        variables: {
          campaignOrder: currentCampaignOrder,
          oppName: currentCampaignOrder.name,
          sfOpportunityId: currentCampaignOrder.salesforceId,
          name,
          decisionMakerFirstName,
          decisionMakerLastName,
          salesforceAccountName: salesforceAccountNameDirect,
          proposalFilename: salesforceOpportunityProposalFilename,
          decisionMakerTitle,
          decisionMakerPhone,
        },
      });
      message.destroy();
      message.success('PandaDoc sent successfully');
      // handleApprove();
      setShowPandadocModal(false);
    } catch (error) {
      console.error('Error sending PandaDoc:', error);
      message.destroy();
      message.error('Error sending PandaDoc');
    }
  };

  const campaignOrderSalesforceId = currentCampaignOrder?.salesforceId;
  const advertiserSalesforceAccountId = currentCampaignOrder?.advertiser?.salesforceId;
  useEffect(() => {
    if (!showPandadocModal) return;
    if (advertiserSalesforceAccountId) {
      fetchSalesforceAccountNameDirect({
        variables: { salesforceAccountId: advertiserSalesforceAccountId },
      });
    }
    if (campaignOrderSalesforceId) {
      fetchSalesforceOpportunityProposalFilename({
        variables: { salesforceOpportunityId: campaignOrderSalesforceId },
      });
    }
  }, [
    advertiserSalesforceAccountId,
    campaignOrderSalesforceId,
    fetchSalesforceAccountNameDirect,
    fetchSalesforceOpportunityProposalFilename,
    showPandadocModal,
  ]);

  useEffect(() => {
    if (currentCampaignOrder && currentCampaignOrder.campaigns) {
      // Check if there are any line items marked for delivery
      const deliveryLineItems = currentCampaignOrder.campaigns.reduce((acc, campaign) => {
        return [
          ...acc,
          ...(campaign.lineItems
            ? campaign.lineItems.filter((lineItem) => lineItem.markedForDelivery !== false)
            : []),
        ];
      }, []);
      setHasDeliveryLineItems(deliveryLineItems.length > 0);

      // get all medias (ad units) from campaign.lineItems.adGroup.adGroupCreatives.medias
      // Note: Each row in the Ad Units table is a media, so we count at the media level
      const medias = currentCampaignOrder.campaigns.reduce((acc, campaign) => {
        return [
          ...acc,
          ...(campaign.lineItems
            ? campaign.lineItems
                .filter((lineItem) => lineItem.markedForDelivery !== false) // Only include line items marked for delivery
                .reduce((acc, lineItem) => {
                  return [
                    ...acc,
                    ...(lineItem.adGroup && lineItem.adGroup.adGroupCreatives
                      ? lineItem.adGroup.adGroupCreatives.reduce((acc, adGroupCreative) => {
                          return [...acc, ...(adGroupCreative.medias || [])];
                        }, [])
                      : []),
                  ];
                }, [])
            : []),
        ];
      }, []);

      // get the count of ad units (medias) that are pending approval
      const pendingApproval = medias.filter(
        (media) => media.status === 'PENDING' || !media.status
      ).length;
      setPendingApproval(pendingApproval);

      // get the count of ad units (medias) that are approved
      const approved = medias.filter((media) => media.status === 'APPROVED').length;
      setApproved(approved);

      // get the count of ad units (medias) that need revision
      const needsRevision = medias.filter((media) => media.status === 'REJECTED').length;
      setNeedsRevision(needsRevision);
    }
  }, [currentCampaignOrder]);

  // Helper function to determine which alert message to show
  const getApprovalBlockerMessage = () => {
    // Priority order: No Delivery Line Items > Revision > Pending Approval > No Approvals
    if (!hasDeliveryLineItems) {
      return {
        type: 'warning',
        message: <span style={{ fontSize: '13px' }}>No Line Items Marked for Delivery</span>,
        description: (
          <span style={{ fontSize: '13px' }}>
            At least one line item must be marked for delivery before the campaign order can be
            approved.
          </span>
        ),
      };
    }

    if (needsRevision > 0) {
      return {
        type: 'warning',
        message: <span style={{ fontSize: '13px' }}>Revisions Required</span>,
        description: (
          <span
            style={{ fontSize: '13px' }}
          >{`${needsRevision} ad unit${needsRevision > 1 ? 's' : ''} need${needsRevision === 1 ? 's' : ''} revision before approval. Please address all revision requests.`}</span>
        ),
      };
    }

    if (pendingApproval > 0) {
      return {
        type: 'info',
        message: <span style={{ fontSize: '13px' }}>Pending Approvals</span>,
        description: (
          <span
            style={{ fontSize: '13px' }}
          >{`${pendingApproval} ad unit${pendingApproval > 1 ? 's are' : ' is'} still pending approval. Please review and approve all ad units to continue.`}</span>
        ),
      };
    }

    if (approved === 0) {
      return {
        type: 'warning',
        message: <span style={{ fontSize: '13px' }}>No Approved Ad Units</span>,
        description: (
          <span style={{ fontSize: '13px' }}>
            At least one ad unit must be approved before the campaign order can be approved.
          </span>
        ),
      };
    }

    return null;
  };

  return (
    <>
      <Card title="Review Details" className="campaign-orderqueue-summary">
        {currentCampaignOrder.reviewNotes ? (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text>Notes</Text>
            <Text type="secondary">{currentCampaignOrder.reviewNotes}</Text>
            <Space size="small" style={{ width: '100%' }}>
              <Button
                disabled={loadingUpdateCampaignOrder}
                type="link"
                block
                onClick={() => setShowNotesDialog(true)}
              >
                Edit
              </Button>
              <Button
                disabled={loadingUpdateCampaignOrder}
                type="link"
                block
                onClick={handleResetNote}
              >
                Reset
              </Button>
            </Space>
          </Space>
        ) : (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text>Campaign Status</Text>
            <Text type="secondary">Pending Review</Text>
          </Space>
        )}

        <Divider />
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Text>Ad Units</Text>
          <Text type="secondary">{pendingApproval} Pending Approval</Text>
          <Text type="secondary">{approved} Approved</Text>
          <Text type="secondary">{needsRevision} Needs Revision</Text>
        </Space>

        <Divider />

        {/* Alert for disabled Approve button - show when approval is blocked */}
        {(() => {
          const isApprovalDisabled =
            !hasDeliveryLineItems || approved === 0 || pendingApproval > 0 || needsRevision > 0;
          const alertConfig = getApprovalBlockerMessage();

          return (
            isApprovalDisabled &&
            alertConfig && (
              <Alert
                type={alertConfig.type}
                message={alertConfig.message}
                description={alertConfig.description}
                showIcon
                style={{ marginBottom: 16 }}
              />
            )
          );
        })()}

        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          {!currentCampaignOrder.reviewNotes && (
            <Button
              disabled={loadingUpdateCampaignOrder}
              style={{ width: '100%' }}
              onClick={() => setShowNotesDialog(true)}
            >
              Add Note
            </Button>
          )}
          <Button
            disabled={loadingUpdateCampaignOrder}
            style={{ width: '100%' }}
            onClick={handleRequestRevision}
          >
            Request Revision
          </Button>
          <Button
            //uncomment later, commented for testing purposes only
            disabled={
              !hasDeliveryLineItems ||
              approved === 0 ||
              pendingApproval > 0 ||
              needsRevision > 0 ||
              loadingUpdateCampaignOrder
            }
            style={{ width: '100%' }}
            onClick={() => setShowPandadocModal(true)}
          >
            Approve
          </Button>
        </Space>
      </Card>

      {showNotesDialog && (
        <CampaignOrderQueueReviewNotesDialog
          visible={showNotesDialog}
          setVisible={setShowNotesDialog}
        />
      )}

      {showRevisionDialogSuccess && (
        <Modal
          visible={showRevisionDialogSuccess}
          title="REVISIONS REQUESTED"
          onCancel={() => setShowRevisionDialogSuccess(false)}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                setShowRevisionDialogSuccess(false);
                // Redirect to campaign order queue queued tab
                history.push('/campaigns/v2/orderqueue/queued');
              }}
            >
              Okay
            </Button>,
          ]}
        >
          <Text>Revisions for this campaign have been requested.</Text>
        </Modal>
      )}
      {showPandadocModal && (
        <Modal
          visible={showPandadocModal}
          title={
            <span style={{ fontSize: 16, fontWeight: 600, color: '#1a1a1a' }}>
              Select Salesforce Opportunity
            </span>
          }
          onCancel={() => setShowPandadocModal(false)}
          onOk={handleSendPandaDoc}
          okText="Approve"
          okButtonProps={{
            style: { borderRadius: 8 },
            loading: loadingSendPandaDocFromOpportunity,
          }}
          cancelButtonProps={{ style: { borderRadius: 8 } }}
          style={{ borderRadius: 12 }}
          bodyStyle={{ padding: '24px 28px' }}
        >
          <div
            style={{
              background: '#f9fafb',
              borderRadius: 8,
              padding: '14px 16px',
              marginBottom: 20,
              border: '1px solid #e8ecf0',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Text style={{ fontSize: 13, color: '#6b7280' }}>
                <span style={{ color: '#374151', fontWeight: 500 }}>Account ID: </span>
                {currentCampaignOrder.advertiser.salesforceId || (
                  <span style={{ color: '#9ca3af' }}>—</span>
                )}
              </Text>
              <Text style={{ fontSize: 13, color: '#6b7280' }}>
                <span style={{ color: '#374151', fontWeight: 500 }}>Account Name: </span>
                {loadingSalesforceAccountNameDirect
                  ? 'Loading...'
                  : salesforceAccountNameDirect || <span style={{ color: '#9ca3af' }}>—</span>}
                {currentCampaignOrder.advertiser.salesforceId && (
                  <a
                    href={`https://mediajel.lightning.force.com/lightning/r/Account/${currentCampaignOrder.advertiser.salesforceId}/view`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: 6, color: '#6366f1' }}
                  >
                    <LinkOutlined />
                  </a>
                )}
              </Text>
            </div>
          </div>
          <Space direction="vertical" style={{ width: '100%', gap: 8, marginBottom: 16 }}>
            <Text style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>
              Select an opportunity to bind to this campaign order:
            </Text>
            <Select
              style={{ width: '100%' }}
              placeholder="Select items"
              value={selectedSalesforceItems}
              onChange={(value) => setSelectedSalesforceItems(value)}
            >
              {externalCRMCampaignIntegrations
                ? externalCRMCampaignIntegrations.map((integration) => (
                    <Select.Option key={integration.id} value={integration.metadata.Name}>
                      {integration.metadata.Name}
                    </Select.Option>
                  ))
                : null}
            </Select>
          </Space>
          <Form layout="vertical">
            <Form.Item
              label={
                <Typography.Text
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.6px',
                  }}
                >
                  Submitter's Name
                </Typography.Text>
              }
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="e.g. Jane Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                  borderRadius: 8,
                  fontSize: 14,
                  height: 40,
                  border: '1px solid #e5e7eb',
                  boxShadow: 'none',
                }}
              />
            </Form.Item>
            <Form.Item
              label={
                <Typography.Text
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.6px',
                  }}
                >
                  Decision Maker First Name
                </Typography.Text>
              }
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="e.g. Jane"
                value={decisionMakerFirstName}
                onChange={(e) => setDecisionMakerFirstName(e.target.value)}
                style={{
                  borderRadius: 8,
                  fontSize: 14,
                  height: 40,
                  border: '1px solid #e5e7eb',
                  boxShadow: 'none',
                }}
              />
            </Form.Item>
            <Form.Item
              label={
                <Typography.Text
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.6px',
                  }}
                >
                  Decision Maker Last Name
                </Typography.Text>
              }
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="e.g. Doe"
                value={decisionMakerLastName}
                onChange={(e) => setDecisionMakerLastName(e.target.value)}
                style={{
                  borderRadius: 8,
                  fontSize: 14,
                  height: 40,
                  border: '1px solid #e5e7eb',
                  boxShadow: 'none',
                }}
              />
            </Form.Item>
            {advertiserHasContract ? (
              <Form.Item
                label={
                  <Typography.Text
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#6b7280',
                      textTransform: 'uppercase',
                      letterSpacing: '0.6px',
                    }}
                  >
                    Phone Number
                  </Typography.Text>
                }
                style={{ marginBottom: 0 }}
              >
                <Input
                  placeholder="e.g. (555) 123-4567"
                  value={decisionMakerPhone}
                  onChange={(e) => setDecisionMakerPhone(e.target.value)}
                  style={{
                    borderRadius: 8,
                    fontSize: 14,
                    height: 40,
                    border: '1px solid #e5e7eb',
                    boxShadow: 'none',
                  }}
                />
              </Form.Item>
            ) : (
              <Form.Item
                label={
                  <Typography.Text
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#6b7280',
                      textTransform: 'uppercase',
                      letterSpacing: '0.6px',
                    }}
                  >
                    Title
                  </Typography.Text>
                }
                style={{ marginBottom: 0 }}
              >
                <Input
                  placeholder="e.g. CEO"
                  value={decisionMakerTitle}
                  onChange={(e) => setDecisionMakerTitle(e.target.value)}
                  style={{
                    borderRadius: 8,
                    fontSize: 14,
                    height: 40,
                    border: '1px solid #e5e7eb',
                    boxShadow: 'none',
                  }}
                />
              </Form.Item>
            )}
          </Form>
        </Modal>
      )}
      {/* {showCreateNewDataModal && (
        <Modal
          visible={showCreateNewDataModal}
          title={null}
          onCancel={() => setShowCreateNewDataModal(false)}
          onOk={() => {
            console.log(newOpportunityName);
            setShowCreateNewDataModal(false);
            handleCreateSalesforceData();
          }}
          okText="Confirm"
          style={{ borderRadius: 16 }}
          bodyStyle={{ padding: '32px 32px 24px' }}
          okButtonProps={{ style: { borderRadius: 8 } }}
          cancelButtonProps={{ style: { borderRadius: 8 } }}
        >
          <Space direction="vertical" style={{ width: '100%', marginBottom: 24 }}>
            <Space align="center" size={10}>
              <Divider
                type="vertical"
                style={{
                  borderColor: '#6366f1',
                  borderWidth: 3,
                  height: 20,
                  margin: 0,
                  borderRadius: 4,
                }}
              />
              <Typography.Text
                strong
                style={{ fontSize: 17, color: '#111827', letterSpacing: '-0.3px' }}
              >
                New Opportunity
              </Typography.Text>
            </Space>
            <Typography.Text type="secondary" style={{ fontSize: 13, paddingLeft: 14 }}>
              Enter a name for the Salesforce opportunity
            </Typography.Text>
          </Space>
          <Form layout="vertical">
            <Form.Item
              label={
                <Typography.Text
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.6px',
                  }}
                >
                  Opportunity Name
                </Typography.Text>
              }
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="e.g. Acme Corp — Q2 Campaign"
                value={newOpportunityName}
                onChange={(e) => {
                  setNewOpportunityName(e.target.value);
                  setShouldCreateOpportunity(true);
                }}
                style={{
                  borderRadius: 8,
                  fontSize: 14,
                  height: 40,
                  border: '1px solid #e5e7eb',
                  boxShadow: 'none',
                }}
              />
            </Form.Item>
            <Form.Item
              label={
                <Typography.Text
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.6px',
                  }}
                >
                  Decision Maker First Name
                </Typography.Text>
              }
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="e.g. Jane"
                value={decisionMakerFirstName}
                onChange={(e) => setDecisionMakerFirstName(e.target.value)}
                style={{
                  borderRadius: 8,
                  fontSize: 14,
                  height: 40,
                  border: '1px solid #e5e7eb',
                  boxShadow: 'none',
                }}
              />
            </Form.Item>
            <Form.Item
              label={
                <Typography.Text
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.6px',
                  }}
                >
                  Decision Maker Last Name
                </Typography.Text>
              }
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="e.g. Doe"
                value={decisionMakerLastName}
                onChange={(e) => setDecisionMakerLastName(e.target.value)}
                style={{
                  borderRadius: 8,
                  fontSize: 14,
                  height: 40,
                  border: '1px solid #e5e7eb',
                  boxShadow: 'none',
                }}
              />
            </Form.Item>
            {advertiserHasContract ? (
              <Form.Item
                label={
                  <Typography.Text
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#6b7280',
                      textTransform: 'uppercase',
                      letterSpacing: '0.6px',
                    }}
                  >
                    Phone Number
                  </Typography.Text>
                }
                style={{ marginBottom: 0 }}
              >
                <Input
                  placeholder="e.g. (555) 123-4567"
                  value={decisionMakerPhone}
                  onChange={(e) => setDecisionMakerPhone(e.target.value)}
                  style={{
                    borderRadius: 8,
                    fontSize: 14,
                    height: 40,
                    border: '1px solid #e5e7eb',
                    boxShadow: 'none',
                  }}
                />
              </Form.Item>
            ) : (
              <Form.Item
                label={
                  <Typography.Text
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#6b7280',
                      textTransform: 'uppercase',
                      letterSpacing: '0.6px',
                    }}
                  >
                    Title
                  </Typography.Text>
                }
                style={{ marginBottom: 0 }}
              >
                <Input
                  placeholder="e.g. CEO"
                  value={decisionMakerTitle}
                  onChange={(e) => setDecisionMakerTitle(e.target.value)}
                  style={{
                    borderRadius: 8,
                    fontSize: 14,
                    height: 40,
                    border: '1px solid #e5e7eb',
                    boxShadow: 'none',
                  }}
                />
              </Form.Item>
            )}
          </Form>
        </Modal>
      )} */}
    </>
  );
};
